const request = {}

request.createRequest = function (params) {
  return { productIds: params.productIdList.join(',') }
}
export default { request }
